var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from "nuxt-class-component";
import { Prop } from 'vue-property-decorator';
import { TsVue } from "~/plugins/TsVue";
import { Getter } from 'vuex-class';
import _ from 'lodash';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(default_1.prototype, "isAuth", {
        get: function () {
            if (!this.authUser)
                return false;
            var currButtons = this.currButtons();
            return currButtons.indexOf(this.name) > -1;
        },
        enumerable: true,
        configurable: true
    });
    default_1.prototype.currButtons = function () {
        var _a = this.currMenuPath, _b = _a[0], menu = _b === void 0 ? 0 : _b, _c = _a[1], child = _c === void 0 ? 0 : _c;
        return _.get(this.menuList, [menu, 'children', child, 'button'], _.get(this.menuList, [menu, 'button'], []));
    };
    __decorate([
        Prop({
            type: String
        })
    ], default_1.prototype, "name", void 0);
    __decorate([
        Getter('currMenu')
    ], default_1.prototype, "currMenuPath", void 0);
    __decorate([
        Getter('menuList')
    ], default_1.prototype, "menuList", void 0);
    __decorate([
        Getter('authUser')
    ], default_1.prototype, "authUser", void 0);
    default_1 = __decorate([
        Component({
            name: 'AuthBox',
            components: {}
        })
    ], default_1);
    return default_1;
}(TsVue));
export default default_1;



//////////////////
// WEBPACK FOOTER
// /opt/node_modules/ts-loader?{"appendTsSuffixTo":[{}],"transpileOnly":true}!/opt/node_modules/vue-loader/lib/selector.js?type=script&index=0!./public/auth/src/main.vue
// module id = vRn0
// module chunks = 28